import {createActions, createReducer} from "reduxsauce";

type State = {
  pendingCount: number;
};

const INITIAL_STATE: State = {
  pendingCount: 0,
};

export const {Types, Creators} = createActions({
  setPendingEmailsCount: ["pendingCount"], // define explicitamente o total
  incrementPendingEmails: [], // +1
  decrementPendingEmails: [], // -1 com piso em 0
  clearPendingEmails: [], // zera
});

const setPendingEmailsCount = (
  state = INITIAL_STATE,
  action: {pendingCount: number},
) => ({
  ...state,
  pendingCount: Math.max(0, Number(action.pendingCount) || 0),
});

const incrementPendingEmails = (state = INITIAL_STATE) => ({
  ...state,
  pendingCount: state.pendingCount + 1,
});

const decrementPendingEmails = (state = INITIAL_STATE) => ({
  ...state,
  pendingCount: Math.max(0, state.pendingCount - 1),
});

const clearPendingEmails = () => ({
  ...INITIAL_STATE,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_PENDING_EMAILS_COUNT]: setPendingEmailsCount,
  [Types.INCREMENT_PENDING_EMAILS]: incrementPendingEmails,
  [Types.DECREMENT_PENDING_EMAILS]: decrementPendingEmails,
  [Types.CLEAR_PENDING_EMAILS]: clearPendingEmails,
});
